
var editarPrecioReparaciones = angular.module('preciosAdmin');

editarPrecioReparaciones.controller('precioAdminController', ['$scope', '$routeParams', '$location', 'preciosAdminService', 'authenticationInfo', 'authenticationService', function ($scope, $routeParams, $location, preciosAdminService, authenticationInfo, authenticationService) {

    $scope.authentication = authenticationInfo;

    precioAdminService.getPrecio($routeParams.id)
            .then(function (response) {
                var data = response.data;
                $scope.precio = data;
                $scope.descripcion = data.Descripcion;
                $scope.preciounitario = data.preciounitario;
            });

    $scope.gestionPrecioReparaciones = function () {
        $location.path("/admin/preciosAdmin");
    }
    $scope.editarPrecio = function () {
        preciosAdminService.put($scope.descripcion, $scope.preciounitario).then(function (response) {
                var result = response.data;
                alert("Precio guardado correctamente");
                //$location.path("/admin/usuarios");
                $location.path("/admin/preciosAdmin ");
            }).catch(function (response) {
                $scope.error = precioAdminService.obtenerPrimerErrorModelState(response.data);
                alert($scope.error);
            });
        }


    }]);